import { Button, Card, Form } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import ToyCreateContent from '../components/ToyCreateContent';

const CreateToy = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const actionButtons = (
    <div className="header-btn-wrapper">
      <Button
        type="primary"
        className="common-button mr-16"
        size="middle"
        onClick={() => history?.push(`${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}`)}
      >
        Cancel
      </Button>
      <Button
        className="common-button"
        size="middle"
        onClick={form.submit}
        loading={isSubmitLoading}
        disabled={isDisabled}
      >
        Save
      </Button>
    </div>
  );

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton customLink={`${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}`} />
        <div className="portal-header">Add New Toy</div>
      </Portal>
      <Portal portalId="header-right-content">{actionButtons}</Portal>
      <Portal portalId="header-right-content-phones">{actionButtons}</Portal>
      <Card className="full-height-with-nav" title="Toy Details">
        <ToyCreateContent
          form={form}
          onSaved={() =>
            history?.replace(`${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}`)
          }
          onDirtyChange={() => setIsDisabled(false)}
          onSubmittingChange={setIsSubmitLoading}
        />
      </Card>
    </>
  );
};

export default CreateToy;
